import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import AppRootComponent from './AppRootComponent';
import { GlobalStateProvider } from './GlobalStateContext';
import * as Constants from './helpers/Constants';

ReactDOM.render(
    <GlobalStateProvider>
        <BrowserRouter basename={Constants.URL}>
            <AppRootComponent />
        </BrowserRouter>
    </GlobalStateProvider>,
    document.getElementById('app')
);
